import type { DiagramSpec } from "./types"

export interface DiagramHistoryState {
  undoStack: DiagramSpec[]
  redoStack: DiagramSpec[]
}

export interface DiagramHistoryResult extends DiagramHistoryState {
  diagram: DiagramSpec
  changed: boolean
}

export function pushUndoEntry(history: DiagramHistoryState, diagram: DiagramSpec, limit: number): DiagramHistoryState {
  return {
    undoStack: [...history.undoStack.slice(-limit + 1), diagram],
    redoStack: [],
  }
}

export function undoDiagramEdit(
  history: DiagramHistoryState,
  diagram: DiagramSpec,
  limit: number,
): DiagramHistoryResult {
  const previous = history.undoStack.at(-1)
  if (!previous) {
    return { ...history, diagram, changed: false }
  }

  return {
    diagram: previous,
    undoStack: history.undoStack.slice(0, -1),
    redoStack: [...history.redoStack.slice(-limit + 1), diagram],
    changed: true,
  }
}

export function redoDiagramEdit(
  history: DiagramHistoryState,
  diagram: DiagramSpec,
  limit: number,
): DiagramHistoryResult {
  const next = history.redoStack.at(-1)
  if (!next) {
    return { ...history, diagram, changed: false }
  }

  return {
    diagram: next,
    undoStack: [...history.undoStack.slice(-limit + 1), diagram],
    redoStack: history.redoStack.slice(0, -1),
    changed: true,
  }
}
